import { PackageVariantRemoveIcon } from './PackageVariantRemoveIcon';

/**
 * author: Michael Irigoyen
 * id 1E482E98-310D-4A28-B461-DD48ADE915E8
 * name package-variant-remove
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-remove.svg
 * tags
 */
export const BoxVariantRemoveIcon = PackageVariantRemoveIcon;
export default BoxVariantRemoveIcon